<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useLocaleStore } from '../../stores/locale'
import { SUPPORTED_LOCALES, type SupportedLocale } from '../../i18n'
import AppDropdown from '../ui/AppDropdown.vue'
import AppIcon from '../ui/AppIcon.vue'

const locale = useLocaleStore()
const { t } = useI18n()

function choose(lang: SupportedLocale, close: () => void) {
  close()
  void locale.setLocale(lang)
}
</script>

<template>
  <AppDropdown>
    <template #trigger>
      <button
        type="button"
        :aria-label="t('languageSwitcher.label')"
        class="flex items-center gap-1.5 px-2.5 py-1.5 rounded text-xs font-semibold uppercase tracking-wide text-on-surface-variant hover:bg-surface-container-high transition-colors cursor-pointer"
      >
        <AppIcon name="language" size="sm" />
        <span>{{ locale.current }}</span>
        <AppIcon name="expand_more" size="sm" />
      </button>
    </template>
    <template #default="{ close }">
      <button
        v-for="lang in SUPPORTED_LOCALES"
        :key="lang"
        role="menuitem"
        type="button"
        class="w-full flex items-center justify-between px-3 py-2 text-sm text-on-surface hover:bg-surface-container-high transition-colors cursor-pointer"
        :class="{ 'font-semibold text-primary': lang === locale.current }"
        @click="choose(lang, close)"
      >
        <span>{{ t(`languages.${lang}`) }}</span>
        <AppIcon v-if="lang === locale.current" name="check" size="sm" class="text-primary" />
      </button>
    </template>
  </AppDropdown>
</template>
